module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    ref: "rowcol",
    attrs: {
      "span": _vm.colspan
    }
  }, [_c('div', {
    staticClass: "ws-field-item el-form-item"
  }, [_c('label', {
    staticClass: "ws-field-item-label el-form-item__label",
    style: (_vm.labelStyle),
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    style: (_vm.inputStyle)
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0dc3cf4f!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/field.vue
// module id = 297
// module chunks = 99 100